// Link text for review & submit page errors
// key = "name" from `form.formErrors.errors`
// see src/platform/forms-system/docs/reviewErrors.md
export default {
  servicePeriods:
    'Military service history (fill in any missing information for branch of service or service start and end dates)',
  servedInCombatZonePost911:
    'Did you serve in a combat zone after September 11, 2001? (select yes or no)',
  ratedDisabilities:
    'Rated disability (select the disability you’re filing for)',
  newDisabilities: 'Add at least one condition to your claim',
  'view:newDisabilitiesValidation':
    'Review your conditions for missing information (return to conditions chapter and look for "incomplete" labels)',
  'view:claimType': 'Please select at least one type of condition',
  cause: 'What caused this condition? (select from the list of causes)',
  hasMilitaryRetiredPay:
    'Have you ever received military retirement pay? (select yes or no)',
  hasTrainingPay:
    'Do you expect to receive active or inactive duty training pay? (select yes or no)',
  'view:powStatus': 'Are you a former POW? (select yes or no)',
  'view:selectableEvidenceTypes':
    'Types of medical records (select at least one type)',
  'view:hasMedicalRecords':
    'Medical records that support your disability claim (select yes or no)',
  'view:hasOtherEvidence':
    'Supporting documents and additional forms for your disability claim (select yes or no)',
  additionalDocuments:
    'Supporting documents and additional forms (upload at least one file)',
  privateMedicalRecordAttachments:
    'Private medical records (upload at least one file)',
  'view:hasPrivateRecordsToUpload':
    'Do you want to upload your private medical records? (select yes or no)',
  primaryPhone: 'Contact information (enter your phone number)',
  emailAddress: 'Contact information (enter your email address)',
  city: 'Contact information (enter a city for your mailing address)',
  addressLine1: 'Contact information (enter a street address)',
  state: 'Contact information (enter a state for your mailing address)',
  zipCode:
    'Contact information (enter a valid postal code for your mailing address)',
  homelessOrAtRisk:
    'Are you homeless or at risk of becoming homeless? (select one of the answers)',
  isVaEmployee: 'Are you a VA employee? (select yes or no)',
  'toxicExposure.gulfWar1990Details.afghanistan.startDate':
    'Service start date for Afghanistan',
  'toxicExposure.gulfWar1990Details.afghanistan.endDate':
    'Service end date for Afghanistan',
  'toxicExposure.gulfWar1990Details.bahrain.startDate':
    'Service start date for Bahrain',
  'toxicExposure.gulfWar1990Details.bahrain.endDate':
    'Service end date for Bahrain',
  'toxicExposure.gulfWar1990Details.egypt.startDate':
    'Service start date for Egypt',
  'toxicExposure.gulfWar1990Details.egypt.endDate':
    'Service end date for Egypt',
  'toxicExposure.gulfWar1990Details.iraq.startDate':
    'Service start date for Iraq',
  'toxicExposure.gulfWar1990Details.iraq.endDate': 'Service end date for Iraq',
  'toxicExposure.gulfWar1990Details.israel.startDate':
    'Service start date for Israel',
  'toxicExposure.gulfWar1990Details.israel.endDate':
    'Service end date for Israel',
  'toxicExposure.gulfWar1990Details.jordan.startDate':
    'Service start date for Jordan',
  'toxicExposure.gulfWar1990Details.jordan.endDate':
    'Service end date for Jordan',
  'toxicExposure.gulfWar1990Details.kuwait.startDate':
    'Service start date for Kuwait',
  'toxicExposure.gulfWar1990Details.kuwait.endDate':
    'Service end date for Kuwait',
  'toxicExposure.gulfWar1990Details.neutralzone.startDate':
    'Service start date for the neutral zone between Iraq and Saudi Arabia',
  'toxicExposure.gulfWar1990Details.neutralzone.endDate':
    'Service end date for the neutral zone between Iraq and Saudi Arabia',
  'toxicExposure.gulfWar1990Details.oman.startDate':
    'Service start date for Oman',
  'toxicExposure.gulfWar1990Details.oman.endDate': 'Service end date for Oman',
  'toxicExposure.gulfWar1990Details.qatar.startDate':
    'Service start date for Qatar',
  'toxicExposure.gulfWar1990Details.qatar.endDate':
    'Service end date for Qatar',
  'toxicExposure.gulfWar1990Details.saudiarabia.startDate':
    'Service start date for Saudi Arabia',
  'toxicExposure.gulfWar1990Details.saudiarabia.endDate':
    'Service end date for Saudi Arabia',
  'toxicExposure.gulfWar1990Details.somalia.startDate':
    'Service start date for Somalia',
  'toxicExposure.gulfWar1990Details.somalia.endDate':
    'Service end date for Somalia',
  'toxicExposure.gulfWar1990Details.syria.startDate':
    'Service start date for Syria',
  'toxicExposure.gulfWar1990Details.syria.endDate':
    'Service end date for Syria',
  'toxicExposure.gulfWar1990Details.uae.startDate':
    'Service start date for The United Arab Emirates (UAE)',
  'toxicExposure.gulfWar1990Details.uae.endDate':
    'Service end date for The United Arab Emirates (UAE)',
  'toxicExposure.gulfWar1990Details.turkey.startDate':
    'Service start date for Turkey',
  'toxicExposure.gulfWar1990Details.turkey.endDate':
    'Service end date for Turkey',
  'toxicExposure.gulfWar1990Details.waters.startDate':
    'Service start date for Oman',
  'toxicExposure.gulfWar1990Details.waters.endDate':
    'Service end date for Oman',
  'toxicExposure.gulfWar1990Details.airspace.startDate':
    'Service start date for the airspace above Gulf War locations on or after August 2, 1990',
  'toxicExposure.gulfWar1990Details.airspace.endDate':
    'Service end date for the airspace above Gulf War locations on or after August 2, 1990',
  'toxicExposure.gulfWar2001Details.djibouti.startDate':
    'Service start date for Djibouti',
  'toxicExposure.gulfWar2001Details.djibouti.endDate':
    'Service end date for Djibouti',
  'toxicExposure.gulfWar2001Details.lebanon.startDate':
    'Service start date for Lebanon',
  'toxicExposure.gulfWar2001Details.lebanon.endDate':
    'Service end date for Lebanon',
  'toxicExposure.gulfWar2001Details.uzbekistan.startDate':
    'Service start date for Uzbekistan',
  'toxicExposure.gulfWar2001Details.uzbekistan.endDate':
    'Service end date for Uzbekistan',
  'toxicExposure.gulfWar2001Details.yemen.startDate':
    'Service start date for Yemen',
  'toxicExposure.gulfWar2001Details.yemen.endDate':
    'Service end date for Yemen',
  'toxicExposure.gulfWar2001Details.airspace.startDate':
    'Service start date for the airspace above Service post-9/11 locations',
  'toxicExposure.gulfWar2001Details.airspace.endDate':
    'Service end date for the airspace above Service post-9/11 locations',
  'toxicExposure.herbicideDetails.cambodia.startDate':
    'Service start date for Cambodia at Mimot or Krek, Kampong Cham Province',
  'toxicExposure.herbicideDetails.cambodia.endDate':
    'Service end date for Cambodia at Mimot or Krek, Kampong Cham Province',
  'toxicExposure.herbicideDetails.guam.startDate':
    'Service start date for Guam, American Samoa, or their territorial waters',
  'toxicExposure.herbicideDetails.guam.endDate':
    'Service end date for Guam, American Samoa, or their territorial waters',
  'toxicExposure.herbicideDetails.koreandemilitarizedzone.startDate':
    'Service start date for In or near the Korean demilitarized zone',
  'toxicExposure.herbicideDetails.koreandemilitarizedzone.endDate':
    'Service end date for In or near the Korean demilitarized zone',
  'toxicExposure.herbicideDetails.johnston.startDate':
    'Service start date for Johnston Atoll or on a ship that called at Johnston Atoll',
  'toxicExposure.herbicideDetails.johnston.endDate':
    'Service end date for Johnston Atoll or on a ship that called at Johnston Atoll',
  'toxicExposure.herbicideDetails.laos.startDate':
    'Service start date for Laos',
  'toxicExposure.herbicideDetails.laos.endDate': 'Service end date for Laos',
  'toxicExposure.herbicideDetails.c123.startDate':
    'Service start date for somewhere you had contact with C-123 airplanes while serving in the Air Force or the Air Force Reserves',
  'toxicExposure.herbicideDetails.c123.endDate':
    'Service end date for somewhere you had contact with C-123 airplanes while serving in the Air Force or the Air Force Reserves',
  'toxicExposure.herbicideDetails.thailand.startDate':
    'Service start date for a U.S. or Royal Thai military base in Thailand',
  'toxicExposure.herbicideDetails.thailand.endDate':
    'Service end date for a U.S. or Royal Thai military base in Thailand',
  'toxicExposure.herbicideDetails.vietnam.startDate':
    'Service start date for Vietnam or the waters in or off of Vietnam',
  'toxicExposure.herbicideDetails.vietnam.endDate':
    'Service end date for Vietnam or the waters in or off of Vietnam',
  'toxicExposure.otherHerbicideLocations.startDate':
    'Exposure start date for other Agent Orange locations',
  'toxicExposure.otherHerbicideLocations.endDate':
    'Exposure end date for other Agent Orange locations ',
  'toxicExposure.otherHerbicideLocations.description':
    'Agent Orange other locations',
  'toxicExposure.otherExposuresDetails.asbestos.startDate':
    'Exposure start date for Asbestos',
  'toxicExposure.otherExposuresDetails.asbestos.endDate':
    'Exposure end date for Asbestos',
  'toxicExposure.otherExposuresDetails.chemical.startDate':
    'Exposure start date for chemical and biological warfare testing through Project 112 or Project Shipboard Hazard and Defense (SHAD)',
  'toxicExposure.otherExposuresDetails.chemical.endDate':
    'Exposure end date for chemical and biological warfare testing through Project 112 or Project Shipboard Hazard and Defense (SHAD)',
  'toxicExposure.otherExposuresDetails.water.startDate':
    'Exposure start date for contaminated water at Camp Lejeune or MCAS New River, North Carolina',
  'toxicExposure.otherExposuresDetails.water.endDate':
    'Exposure end date for contaminated water at Camp Lejeune or MCAS New River, North Carolina',
  'toxicExposure.otherExposuresDetails.mos.startDate':
    'Exposure start date for Military Occupational Specialty (MOS)-related toxin',
  'toxicExposure.otherExposuresDetails.mos.endDate':
    'Exposure end date for Military Occupational Specialty (MOS)-related toxin',
  'toxicExposure.otherExposuresDetails.mustardgas.startDate':
    'Exposure start date for Mustard Gas',
  'toxicExposure.otherExposuresDetails.mustardgas.endDate':
    'Exposure end date for Mustard Gas',
  'toxicExposure.otherExposuresDetails.radiation.startDate':
    'Exposure start date for Radiation',
  'toxicExposure.otherExposuresDetails.radiation.endDate':
    'Exposure end date for Radiation',
  'toxicExposure.specifyOtherExposures.description':
    'Other toxic exposures not listed',
  'toxicExposure.specifyOtherExposures.startDate':
    'Exposure start date for other toxic exposures',
  'toxicExposure.specifyOtherExposures.endDate':
    'Exposure end date for other toxic exposures',
  separationHealthAssessmentUploads: 'Upload your Separation Health Assessment',
  _override: (error, context = {}) => {
    if (typeof error !== 'string') {
      return null;
    }

    // Supporting evidence enhancement fields live on pages the review-page
    // error summary can't attribute on its own, so map each to its chapter +
    // page. We intentionally omit navigationType: 'redirect' so the error link
    // uses the default in-place accordion edit flow — that keeps the veteran on
    // the review page, where finishing an edit re-runs validation and re-syncs
    // the error summary (rather than leaving it stale, which redirecting away
    // to a standalone page would).
    if (error.includes('view:hasMedicalRecords')) {
      return {
        chapterKey: 'supportingEvidence',
        pageKey: 'evidenceRequest',
      };
    }
    // `view:selectableEvidenceTypes` is one object shared by two pages, so both
    // pages' errors reach _override containing that substring. Disambiguate by
    // the error's `argument` (available on the context via reduceErrors spreading
    // `{...err}`): the "other evidence" question (evidenceChoiceIntro) surfaces a
    // required error with argument `view:hasOtherEvidence`; the VA/Private "select
    // at least one type" error (the medicalRecords "Types of medical records"
    // page) is a custom __errors error with no such argument.
    if (context?.formData?.disability526SupportingEvidenceEnhancement) {
      if (
        error.includes('view:hasOtherEvidence') ||
        context?.argument === 'view:hasOtherEvidence'
      ) {
        return {
          chapterKey: 'supportingEvidence',
          pageKey: 'evidenceChoiceIntro',
        };
      }
      if (error.includes('view:selectableEvidenceTypes')) {
        return {
          chapterKey: 'supportingEvidence',
          pageKey: 'medicalRecords',
        };
      }
    }
    // These upload fields are shared across three pages (the legacy page for
    // users with legacy form data resuming on review, and the enhancement
    // flow's V1/V3 upload variants) — pick the one actually active for this
    // formData so the error link lands on a page in the flow.
    if (
      error.includes('additionalDocuments') ||
      error.includes('additionalDocumentsLoop') ||
      error.includes('view:hasAnotherSupportingDocument')
    ) {
      if (context?.formData?.disability526SupportingEvidenceEnhancement) {
        return {
          chapterKey: 'supportingEvidence',
          pageKey: context.formData.disability526SupportingEvidenceFileInputV3
            ? 'evidenceChoiceDocumentsLoopSummary'
            : 'evidenceChoiceAdditionalDocumentsV1',
        };
      }
      return {
        chapterKey: 'supportingEvidence',
        pageKey: 'additionalDocuments',
      };
    }
    if (error.includes('privateMedicalRecordAttachments')) {
      if (context?.formData?.disability526SupportingEvidenceEnhancement) {
        return {
          chapterKey: 'supportingEvidence',
          pageKey: context.formData.disability526SupportingEvidenceFileInputV3
            ? 'privateMedicalRecordsUpload'
            : 'privateMedicalRecordsUploadV1',
        };
      }
      return {
        chapterKey: 'supportingEvidence',
        pageKey: 'privateMedicalRecordsAttachments',
      };
    }

    // Overrides for newDisabilities array and condition name errors; all other per-item errors fall through to the R&S accordion (the default behavior)
    const conditionsSummaryRedirect = {
      chapterKey: 'disabilities',
      pageKey: 'Summary',
      navigationType: 'redirect',
    };

    // Empty-array validation errors (no conditions added)
    if (
      error === 'newDisabilities' ||
      error === 'instance.newDisabilities' ||
      (error.includes('newDisabilities') &&
        error.includes('does not meet minimum length'))
    ) {
      return conditionsSummaryRedirect;
    }

    // Condition name field errors (missing, duplicate, too long).
    // Custom addError() calls in validateCondition produce an `__errors`
    // array, which reduceErrors resolves to the bare field key "condition"
    // rather than the full "newDisabilities[n].condition" path.
    if (
      error === 'condition' ||
      /newDisabilities\[\d+\]\.condition/.test(error)
    ) {
      return conditionsSummaryRedirect;
    }

    if (error?.endsWith('startDate') || error?.endsWith('endDate')) {
      const errorParts = error.split('.');
      if (error.startsWith('toxicExposure.gulfWar1990Details')) {
        return {
          chapterKey: 'disabilities',
          pageKey: `gulf-war-1990-location-${errorParts[2]}`,
        };
      }
      if (error.startsWith('toxicExposure.gulfWar2001Details')) {
        return {
          chapterKey: 'disabilities',
          pageKey: `gulf-war-2001-location-${errorParts[2]}`,
        };
      }
      if (error.startsWith('toxicExposure.herbicideDetails')) {
        return {
          chapterKey: 'disabilities',
          pageKey: `herbicide-location-${errorParts[2]}`,
        };
      }
      if (error.startsWith('toxicExposure.otherExposuresDetails')) {
        return {
          chapterKey: 'disabilities',
          pageKey: `additional-exposure-${errorParts[2]}`,
        };
      }
      if (error.startsWith('toxicExposure.otherHerbicideLocations')) {
        return {
          chapterKey: 'disabilities',
          pageKey: `herbicide-location-other`,
        };
      }
      if (error.startsWith('toxicExposure.specifyOtherExposures')) {
        return {
          chapterKey: 'disabilities',
          pageKey: `additional-exposure-other`,
        };
      }
    }

    if (error === 'toxicExposure.otherHerbicideLocations.description') {
      return {
        chapterKey: 'disabilities',
        pageKey: `herbicideLocations`,
      };
    }

    if (error === 'toxicExposure.specifyOtherExposures.description') {
      return {
        chapterKey: 'disabilities',
        pageKey: `additional-exposures`,
      };
    }

    // always return null for non-matches
    return null;
  },
};
